var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"popup__button",class:{ disable: _vm.disable },on:{"click":_vm.buttonClick}},[_c('span',{staticClass:"popup__button-text"},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }